import i18n from '../helpers/i18nHelpers'
import moment from 'moment-timezone'
import store from '../store/store'

moment.tz.setDefault('Asia/Bangkok')

const urlParser = document.createElement('a')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function firstName (name) {
  let firstName = ''
  if (name) {
    try {
      let arr = name.split(' ')
      if (arr.length === 1) {
        firstName = arr[0]
      } else if (arr.length === 2) {
        firstName = arr[0] + ' ' + arr[1].substring(0, 1) + '.'
      } else {
        const max = arr.length - 1
        for (let i = 0; i < max; i++) {
          firstName += arr[i] + ' '
        }
        if (arr[max]) {
          firstName += arr[max].substring(0, 1) + '.'
        }
      }
    } catch (err) {
      console.log(err)
    }
  }
  return firstName
}

export function internationalCode (tel) {
  let arr = tel.split(' ')
  return arr[0]
}

export function responseTime (avgTime) {
  let responseTime
  avgTime = Math.round(avgTime)
  if (avgTime < 60) {
    responseTime = i18n.t('message.professional.response_time01')
  } else if (avgTime > 60 && avgTime < 180) {
    responseTime = i18n.t('message.professional.response_time02')
  } else {
    responseTime = i18n.t('message.professional.response_time03')
  }

  return responseTime
}

export function reviewDurationText (orderData) {
  let result = i18n.t('message.my_reservations.limit_time_for_review01')
  result += ' ' + orderData.review_days + ' '
  result += i18n.t('message.my_reservations.limit_time_for_review02') + ' '
  result += firstName(orderData.professional_name)
  result += (i18n.locale === 'en') ? '. ' : ' '
  result += i18n.t('message.my_reservations.limit_time_for_review03')
  return result
}

export function bankTransferDurationText (orderData, globalState) {
  const paymentMethod = orderData.payment_data.method
  const startDate = orderData.order_date
  const endDate = orderData.cleaning_date
  const convertedStartDate = moment(startDate, 'YYYY-MM-DD HH:mm:ss')
  const convertedEndDate = moment(endDate, 'YYYY-MM-DD HH:mm:ss')
  const diffHours = moment.duration(convertedEndDate.diff(convertedStartDate)).asHours()
  let hours = 2
  if (paymentMethod === 'pending') {
    hours = globalState.configData.bank_transfer_hours_pending
  } else {
    if (diffHours <= 3) {
      hours = 1
    }
  }
  let dtFormat = (i18n.locale === 'en') ? 'MMM DD, YYYY (HH:mm)' : 'DD MMM YYYY (HH:mm)'
  const expiredTime = moment(orderData.order_date, 'YYYY-MM-DD HH:mm:ss').add(hours, 'hours')
  const strExpiredTime = moment(expiredTime).format(dtFormat)
  let result
  if (paymentMethod === 'promptpay') {
    result = i18n.t('message.bank_transfer.confirm_bank_transfer03')
  } else { // pending and bank_transfer
    result = i18n.t('message.bank_transfer.confirm_bank_transfer01')
  }
  result += ' <label>' + strExpiredTime + '</label> '
  if (orderData.selected_professional_id > 0) {
    result += i18n.t('message.bank_transfer.confirm_bank_transfer02')
  }
  return result
}

export function orderPaymentData (paymentData) {
  let result = ''
  switch (paymentData.method) {
    case 'credit_card':
      result = i18n.t('message.payment_method.credit_debit_card')
      if (paymentData.last_digits) {
        result = cardBrand(paymentData.brand) + ' ●●●● ' + paymentData.last_digits
      }
      break
    case 'ibanking':
      result = ibankingBank(paymentData.bank) + ' ' + i18n.t('message.payment_method.internet_banking')
      break
    case 'bank_transfer':
      result = i18n.t('message.payment_method.bank_transfer')
      break
    case 'wallet':
      result = i18n.t('message.payment_method.wallet')
      break
    case 'pending':
      result = i18n.t('message.payment_method.pending')
      break
    case 'promptpay':
      result = i18n.t('message.payment_method.promptpay')
      break
  }
  result = i18n.t('message.payment_method.paid_by') + ' ' + result
  return result
}

function cardBrand (brand) {
  let src = ''
  switch (brand.toLowerCase()) {
    case 'visa':
      src = '/static/img/brand-visa.svg'
      break
    case 'mastercard':
      src = '/static/img/brand-master-card.svg'
      break
    case 'jcb':
      src = '/static/img/brand-jcb.svg'
      break
  }
  return '<img src="' + src + '" height="36">'
}

function ibankingBank (bankName) {
  let src = ''
  switch (bankName.toLowerCase()) {
    case 'scb':
      src = '/static/img/icon-bank-SCB.svg'
      break
    case 'ktb':
      src = '/static/img/icon-bank-KTB.svg'
      break
    case 'bay':
      src = '/static/img/icon-bank-BAY.svg'
      break
    case 'bbl':
      src = '/static/img/icon-bank-BBL.svg'
      break
  }
  return '<img src="' + src + '" height="32">'
}

export function declinedReason (declinedOrderData) {
  let reason = ''
  switch (declinedOrderData.issue) {
    case 'transportation':
      reason = i18n.t('message.declined_booking.issue_transportation')
      break
    case 'duration':
      reason = i18n.t('message.declined_booking.issue_duration')
      break
    case 'place':
      reason = i18n.t('message.declined_booking.issue_place')
      break
    case 'other':
      reason = declinedOrderData.remark
  }
  return reason
}

export function multiLangName (data) {
  if (!data) {
    return ''
  }
  return (i18n.locale === 'th') ? data.name_th : data.name_en
}

export function serviceParentName (serviceId, services = null) {
  let serviceParentName = ''
  if (services) {
    serviceParentName = (i18n.locale === 'en') ? services[serviceId].name_en : services[serviceId].name_th
    const parentId = services[serviceId].parent_id
    if (parentId > 0) {
      serviceParentName = (i18n.locale === 'en') ? services[parentId].name_en : services[parentId].name_th
    }
  }
  return serviceParentName
}

export function totalPriceWithDiscount (costPerHour, workHour, provinceDiscounts, packageType) {
  costPerHour = parseInt(costPerHour)
  workHour = parseFloat(workHour).toFixed(1)
  let totalPrice = costPerHour * workHour
  if (typeof provinceDiscounts[workHour] !== 'undefined') {
    const provinceDiscount = parseInt(provinceDiscounts[workHour])
    const discount = (totalPrice * provinceDiscount) / 100
    totalPrice = totalPrice - discount
  }
  // Check package type
  if (packageType) {
    const numPerPackage = packageType.num_per_package
    totalPrice = totalPrice * numPerPackage
    // Package discount
    const discountPercent = packageType.discount
    const discountValue = (totalPrice * discountPercent) / 100
    totalPrice = totalPrice - discountValue
  }
  return '฿' + Number(totalPrice).toLocaleString('en')
}

export function calculatePriceWithDiscount (costPerHour, workHour, orderDiscount) {
  costPerHour = parseInt(costPerHour)
  workHour = parseFloat(workHour).toFixed(1)
  let totalPrice = costPerHour * workHour
  if (typeof orderDiscount !== 'undefined') {
    const discount = (totalPrice * orderDiscount) / 100
    totalPrice = totalPrice - discount
  }
  return '฿' + Number(totalPrice).toLocaleString('en')
}

export function discountValue (cost, discount) {
  if (typeof discount !== 'undefined') {
    const costDiscount = (cost * discount) / 100
    cost = cost - costDiscount
  }
  return '-฿' + Number(cost).toLocaleString('en')
}

export function stripSlashes (data) {
  return data.replace(/\\/g, '')
}

export function summaryCleaningDate (date) {
  let resultDate = moment(date, 'DD/MM/YYYY').format('DD MMM YYYY')
  if (i18n.locale === 'en') {
    resultDate = moment(date, 'DD/MM/YYYY').format('MMM DD, YYYY')
  }
  return resultDate
}

export function subscriptionStartDate (date) {
  let resultDate = moment(date, 'DD/MM/YYYY').format('ddd DD MMM YYYY')
  if (i18n.locale === 'en') {
    resultDate = moment(date, 'DD/MM/YYYY').format('ddd, MMM DD, YYYY')
  }
  resultDate = i18n.t('message.subscription.starting') + ' ' + resultDate
  return resultDate
}

export function shortDate (date) {
  let resultDate = moment(date).format('dd DD MMM YYYY')
  if (i18n.locale === 'en') {
    resultDate = moment(date).format('ddd, MMM DD, YYYY')
  }
  return resultDate
}

export function onlyTime (date) {
  return moment(date.replace(' ', 'T')).format('HH:mm')
}

export function prettyNumber (value) {
  let result = Number(value)
  if (result % 1.0 !== 0) {
    return result.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return result.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export function prettyDate (date) {
  if (!date) return ''
  let resultDate = moment(date.replace(' ', 'T')).format('DD MMM YYYY (HH:mm)')
  if (i18n.locale === 'en') {
    resultDate = moment(date.replace(' ', 'T')).format('MMM DD, YYYY (HH:mm)')
  }
  return resultDate
}

export function prettyOnlyDate (date) {
  if (!date) return ''
  let resultDate = moment(date.replace(' ', 'T')).format('DD MMM YYYY')
  if (i18n.locale === 'en') {
    resultDate = moment(date.replace(' ', 'T')).format('MMM DD, YYYY')
  }
  return resultDate
}

export function prettyOnlyMonthYear (date) {
  if (!date) return ''
  let resultDate = moment(date.replace(' ', 'T')).format('MMM YYYY')
  if (i18n.locale === 'en') {
    resultDate = moment(date.replace(' ', 'T')).format('MMM, YYYY')
  }
  return resultDate
}

export function prettyOnlyDateBE (date) {
  if (!date) return ''
  let year = Number(moment(date).format('YYYY')) + 543
  let month = moment(date).format('MM')
  let day = moment(date).format('DD')
  let resultDate = `${day}/${month}/${year}`
  return resultDate
}

export function cleaningDuration (date, workHour) {
  const startTime = moment(date.replace(' ', 'T')).format('HH:mm')
  const endTime = moment(date.replace(' ', 'T')).add(workHour, 'hours').format('HH:mm')
  const result = startTime + ' - ' + endTime
  return result
}

export function joinedDate (date) {
  return moment(date.replace(' ', 'T')).format('MMMM, YYYY')
}

export function timeSpan (date) {
  return moment(date.replace(' ', 'T')).fromNow()
}

export function currency (data) {
  const price = Number(data)
  return '฿' + price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function currencyNoDecimal (data) {
  const price = Number(data)
  return '฿' + price.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function distance (distance) {
  return parseFloat(distance).toFixed(2) + ' ' + i18n.t('message.professional.distance_km')
}

export function shortText (data, length) {
  let shortText = data.replace(/\\/g, '')
  if (shortText.length > length) {
    shortText = shortText.substr(0, length) + '...'
  }
  return shortText
}

export function orderStatus (orderData) {
  try {
    const status = orderData.status
    const cancel = orderData.cancel
    const paidStatus = orderData.paid_status

    let result = ''
    if (paidStatus === 1) {
      if (cancel > 0) {
        result = i18n.t('message.order_status.canceled') + ' ('
        switch (cancel) {
          case 1:
            result += '100%'
            break
          case 2:
            result += '96%'
            break
          case 3:
            result += '50%'
            break
        }
        result += ' ' + i18n.t('message.order_status.refunded') + ')'
        result = '<span class="badge -status -canceled">' + result + '</span>'
      } else {
        switch (status) {
          case 0:
            result = '<span class="badge -status -new">' + i18n.t('message.order_status.new') + '</span>'
            break
          case 1:
            result = '<span class="badge -status -accepted">' + i18n.t('message.order_status.accepted') + '</span>'
            break
          case 2:
            result = '<span class="badge -status -completed">' + i18n.t('message.order_status.completed') + '</span>'
            break
        }
      }
    } else {
      if (cancel > 0) {
        result = i18n.t('message.order_status.canceled') + ' ('
        switch (cancel) {
          case 1:
            result += '100%'
            break
          case 2:
            result += '96%'
            break
          case 3:
            result += '50%'
            break
        }
        result += ' ' + i18n.t('message.order_status.refunded') + ')'
        result = '<span class="badge -status -canceled">' + result + '</span>'
      } else {
        if (orderData.is_expired_bank_transfer) {
          result = '<span class="badge -status -expired">' + i18n.t('message.order_status.expired') + '</span>'
          if (orderData.payment_data && orderData.payment_data.method === 'pending') {
            result = '<span class="badge -status -unpaid">' + i18n.t('message.order_status.unpaid') + '</span>'
          }
        } else {
          if (orderData.bank_transfer_data) {
            result = '<span class="badge -status -waiting-confirm">' + i18n.t('message.order_status.waiting_confirm') + '</span>'
          } else {
            result = '<span class="badge -status -unpaid">' + i18n.t('message.order_status.unpaid') + '</span>'
          }
        }
      }
    }
    return result
  } catch (e) {
    console.log('check error order status', e.message)
    return null
  }
}

export function myPlace (userPlaces, userPlaceId) {
  let result = ''
  for (let key in userPlaces) {
    if (userPlaces[key].id === userPlaceId) {
      result = userPlaces[key].name
      break
    }
  }
  return result
}

export function ratingStar (rating) {
  let html = ''
  if (rating !== '') {
    let arr = rating.toString().split('.')
    let num = parseInt(arr[0])
    let decimal = parseInt(arr[1])

    if (num > 0) {
      for (let i = 0; i < num; i++) {
        html += '<i class="fas fa-star -rating-star"></i>'
      }

      let diff = 5 - num
      for (let j = 0; j < diff; j++) {
        if (j === 0 && decimal > 0) {
          html += '<i class="fas fa-star-half-alt -rating-star"></i>'
        } else {
          html += '<i class="far fa-star -rating-star"></i>'
        }
      }
    } else {
      html += '<i class="far fa-star -rating-star"></i>'
      html += '<i class="far fa-star -rating-star"></i>'
      html += '<i class="far fa-star -rating-star"></i>'
      html += '<i class="far fa-star -rating-star"></i>'
      html += '<i class="far fa-star -rating-star"></i>'
    }
  }
  return html
}

export function professionalJobStatus (order, displayConfirmedStatus) {
  let status = null
  let bulletColor = null

  // if (orderData.complete_cleaning_date) {
  //   status = i18n.t('message.professional.job_status.finished_working')
  //   bulletColor = 'bullet-notification-green'
  // } else if (orderData.start_cleaning_date) {
  //   status = i18n.t('message.professional.job_status.started_working')
  //   bulletColor = 'bullet-notification'
  // } else if (orderData.reach_destination_date) {
  //   status = i18n.t('message.professional.job_status.reach_destination')
  //   bulletColor = 'bullet-notification-orange'
  // } else if (orderData.start_traveling_date) {
  //   status = i18n.t('message.professional.job_status.on_the_way')
  //   bulletColor = 'bullet-notification-yellow'
  // }

  if (order.complete_cleaning_date) {
    status = i18n.t('message.professional.job_status.finished_working')
    bulletColor = 'bullet-notification-green'
  } else if (order.start_cleaning_date) {
    status = i18n.t('message.professional.job_status.started_working')
    bulletColor = 'bullet-notification'
  } else if (order.start_traveling_date) {
    status = i18n.t('message.professional.job_status.on_the_way')
    bulletColor = 'bullet-notification-yellow'
  } else if (order.confirm_cleaning_date && displayConfirmedStatus) {
    status = i18n.t('message.professional.job_status.confirmed')
    bulletColor = 'bullet-notification-green'
  }

  let html = ''
  if (status && bulletColor) {
    html += '<span class=" ' + bulletColor + ' ">'
    html += '<i class="fas fa-circle"></i>'
    html += '</span>'
    html += ' ' + status
  }
  return html
}

export function replaceUrl (message) {
  return message.replace(/((https|http):\/\/[^\s]+)/gi, '<a href="$1" target="_blank">$1</a>')
}

export function numberWithCommas (num) {
  return num.toLocaleString()
}

export function serviceCost (state, preCheckoutData, appliedPromoCode) {
  if (state.totalPrice) {
    let totalCost = state.totalPrice
    let subtotal = totalCost
    let discountCost = 0
    let creditDiscountCost = null

    if (preCheckoutData && preCheckoutData.extra) {
      const extraCost = Number(preCheckoutData.extra.cost)
      totalCost += extraCost
      subtotal += extraCost
    }

    if (appliedPromoCode && appliedPromoCode.is_applied) {
      discountCost = (totalCost * appliedPromoCode.discount) / 100
    }
    let total = totalCost - discountCost

    let serviceVat = total * store.state.globalVal.serviceVat
    serviceVat = Math.round(serviceVat * 100) / 100
    total = total + serviceVat

    if (preCheckoutData && preCheckoutData.is_credit && total) {
      const totalCredits = Number(preCheckoutData.total_credits)
      if (totalCredits >= total) {
        creditDiscountCost = total
      } else {
        creditDiscountCost = totalCredits
      }
      total -= creditDiscountCost
    }
    return [subtotal, discountCost, serviceVat, creditDiscountCost, total]
  }
  return null
}

export function duration (order) {
  const timeFormat = 'HH:mm'
  const startTime = moment(order.cleaning_date).format(timeFormat)
  const endTime = moment(order.cleaning_date, 'YYYY-MM-DD HH:mm:ss').add(order.work_hour, 'hours')
  const strEndTime = moment(endTime).format(timeFormat)
  return startTime + ' - ' + strEndTime
}

export function credits (creditTransaction) {
  const credits = '฿' + creditTransaction.credits
  let html = '<span class="-status-offline">' + credits + '</span>'
  switch (creditTransaction.credit_type) {
    case 'acquired':
      html = '<span class="-status-new">+' + credits + '</span>'
      break
    case 'used':
      html = '<span class="-status-alert">-' + credits + '</span>'
      break
    case 'expired':
      html = '<span class="-status-offline">' + credits + '</span>'
      break
  }
  return html
}

export function transportationTypeIcon (transportationType) {
  let icon = ''
  if (transportationType) {
    const id = Number(transportationType.id)
    switch (id) {
      case 1:
        icon = '<i class="fal fa-car-side fa-lg"></i>'
        break
      case 2:
        icon = '<i class="fal fa-motorcycle fa-lg"></i>'
        break
      case 3:
        icon = '<i class="fal fa-bus-alt fa-lg"></i>'
        break
    }
  }
  return icon
}

export function serviceRequestPaymentStatus (paymentStatus) {
  let strPaymentStatus = null
  switch (paymentStatus) {
    case 0:
      strPaymentStatus = i18n.t('message.service_request.service_request_payment_unpaid')
      break
    case 1:
      strPaymentStatus = i18n.t('message.service_request.service_request_payment_deposit_paid')
      break
    case 2:
      strPaymentStatus = i18n.t('message.service_request.service_request_payment_paid_in_full')
      break
    case 3:
      strPaymentStatus = i18n.t('message.service_request.service_request_payment_promotion_paid')
      break
  }
  return strPaymentStatus
}

export function serviceRequestPaymentType (paymentType) {
  let strPaymentType = null
  switch (paymentType) {
    case 'full':
      strPaymentType = i18n.t('message.service_request.service_request_payment_full')
      break
    case 'deposit':
      strPaymentType = i18n.t('message.service_request.service_request_payment_deposit')
      break
    case 'promotion':
      strPaymentType = i18n.t('message.service_request.service_request_payment_promotion')
      break
  }
  return strPaymentType
}

export function accounting (data) {
  if (data) {
    if (Math.abs(Number(data)) < 0.01) {
      return '0.00'
    }
    return Number(data).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return '0.00'
  }
}

export function accountingNoDecimal (data) {
  if (data) {
    if (Math.abs(Number(data)) < 0.01) {
      return '0'
    }
    return Number(data).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return '0'
  }
}

export function monthTH (month) {
  let result = ''
  month = Number(month)
  switch (month) {
    case 1:
      result = 'มกราคม'
      break
    case 2:
      result = 'กุมภาพันธ์'
      break
    case 3:
      result = 'มีนาคม'
      break
    case 4:
      result = 'เมษายน'
      break
    case 5:
      result = 'พฤษภาคม'
      break
    case 6:
      result = 'มิถุนายน'
      break
    case 7:
      result = 'กรกฎาคม'
      break
    case 8:
      result = 'สิงหาคม'
      break
    case 9:
      result = 'กันยายน'
      break
    case 10:
      result = 'ตุลาคม'
      break
    case 11:
      result = 'พฤศจิกายน'
      break
    case 12:
      result = 'ธันวาคม'
      break
  }
  return result
}

export function orderAdditionalHours (order) {
  if (order && order.book_more_hours && order.book_more_hours.length > 0) {
    let workHours = 0
    for (let orderAdditionalHours of order.book_more_hours) {
      if (orderAdditionalHours.status === 1) {
        workHours += orderAdditionalHours.work_hour
      }
    }
    if (workHours) {
      const strAdditionalHours = `+ ${i18n.t('message.my_reservations.additional_hours')}: ${workHours} ${i18n.tc('message.hour', workHours)}`
      return strAdditionalHours
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/filters/index.js